export default __webpack_public_path__ + "10482f5e94b0aaac32288c9d14b88b38.png";